//react
import * as React from 'react';

//components
import LeadImage from '../components/LeadImage.jsx';

//images
import transportation from '../assets/img/sections/transportation.jpeg';

const Transportation = () => {
  return (
    <section className="section" id="transportation">
      <div className="wrapper" id="transportation-wrapper">
        <LeadImage
          image={transportation}
          text={
            'Nearly 4,000 riders have taken an mbike trip in College Park since the program launched in 2016. (Photo by Tom Hausman/The Diamondback)'
          }
        />

        <h1>Transportation</h1>
        <h3 className="first-line">
          Several major transportation projects will break ground in College
          Park in the coming months, including the long-anticipated Purple Line
          and Route 1’s redevelopment. Other smaller projects have been
          completed or have already begun, including the addition of more than
          80 street lights across College Park and the implementation of a pilot
          bike-share program throughout the city and the University of
          Maryland’s campus.
        </h3>
        <p>
          University and local officials say these changes will be
          transformative in making the city safer and more connected to the
          greater Washington, D.C. Metro area — even after this university’s
          Department of Transportation Services announced it would reduce
          service for the #104 College Park Metro shuttle and other routes.
          <br />
          <br />
          But some aren’t on board with the addition of the Purple Line. Ajay
          Bhatt, president of Friends of Capital Crescent Trail — a nonprofit
          seeking to protect green spaces in Montgomery County — has been
          fighting against the Purple Line for more than a decade. He argued
          light rail technology is outdated and implementing “transit for the
          sake of transit” harms the environment. Only a small, vocal group of
          minority developers stand to benefit from the project, he said.
          <br />
          <br />
          “How many scholarships would that pay for?” Bhatt said of the project,
          which is projected to cost $5.6 billion over 36 years. “Does the
          University of Maryland want five years of disruption for a train track
          going through their campus?”
          <br />
          <br />
          University President Wallace Loh, however, said the Purple Line is
          essential to the region’s economic and social development.
          <br />
          <br />
          “If people ask me, ‘What about the incredible inconvenience, the noise
          and the dust and so forth from construction?’ … I say, ‘That’s the
          price to pay for progress,’” Loh said. “Progress for the next 30 years
          or more.”
        </p>

        <h3 className="list-heading">Accomplisments To Date</h3>

        <p className="p-heading">
          Lighting improvements installed in pedestrian areas underway
        </p>
        <p className="descrip">
          More than 80 new street lights were added or replaced across the city
          in 2015 as part of an effort to improve safety and brighten areas at
          night, said Eric Olson, the partnership’s executive director.
          <br /> <br />
          There have been more projects since then, such as new lights being
          added to the Route 1 bridge over the Paint Branch Trail. The artistic
          lighting was installed by Imaginex, an entertainment lighting company
          founded by university alumnus Eric Mintzer. The lights will be turned
          on when the power source is installed in the coming months, he said.
          <br />
          <br />
          The color of the lights will change every day and can be scheduled
          throughout the year to align with holidays and other special events,
          Mintzer said. He added that he hopes the lights will make the bridge a
          more “vibrant and cooler area” that is “attractive and a cooler place
          to hang out.”
        </p>

        <p className="p-heading">
          10 panels of the Paint Branch sound barrier wall removed to eliminate
          blind corner on Campus Drive
        </p>
        <p className="descrip">
          The panels were removed in January 2017 to allow bicyclists and
          drivers more visibility at the intersection of Campus Drive and the
          Trolley Trail. The changes came after a 77-year-old bicyclist was
          struck and killed on the Trolley Trail in September 2016.
        </p>

        <p className="p-heading">Purple Line broke ground</p>
        <p className="descrip">
          The 16-mile, $5.6 billion Purple Line — which will feature five stops
          on or around this university’s campus — had its groundbreaking last
          summer. Construction for the light rail on this campus is slated to
          begin in the coming months, and it should take about two to three
          years to complete, according to Carlo Colella, the university’s
          administration and finance vice president. Service is expected to
          begin in 2022.
          <br /> <br />
          Loh called the Purple Line project “transformational” because of its
          potential influence on the economy, infrastructure and “social
          cohesion” of the surrounding area. He said The Hotel at the University
          of Maryland “would never have been built” if it weren’t for the plans
          to bring in the Purple Line.
          <br />
          <br />
          Loh added that the Purple Line could lead to job growth. Montgomery
          County — where the Purple Line will have 10 stops — is one of 20 sites
          nationwide that were shortlisted for Amazon’s proposed second
          headquarters, HQ2. Amazon expects the project to come with as many as
          50,000 jobs, and Loh said the Purple Line would help College Park reap
          those benefits.
          <br />
          <br />
          “Not all of them are going to be living in White Flint, Montgomery
          County,” he said. “Many of them will want to live in the College Park
          area, in Prince George’s County because the rents are cheaper, plus
          they’re next to a major university.”
          <br />
          <br />
          Purple Line construction will reduce parking spots on the campus, DOTS
          Executive Director David Allen told The Diamondback in March.
          <br />
          <br />
          Lizandro Galvez, a rising sophomore aerospace engineering major,
          commutes to school by car, because if he took a bus he would have to
          leave his house two hours earlier. He said he didn’t think the Purple
          Line was a good idea because the light rail wouldn’t be convenient for
          students’ busy schedules.
          <br />
          <br />
          “Some students might find it better [to take the light rail] but the
          majority of the time [students] have their own car or use their
          parents’,” Galvez said. “Even though it’s a cost to them, they have
          that liberty to come to and from school whenever they want.”
          <br />
          <br />
          Colella said the university community “needs to be patient with the
          construction activities” and referred to it as a temporary
          inconvenience — similar to the construction of the Edward St. John
          Learning and Teaching Center.
        </p>

        <p className="p-heading">
          Sidewalk Connection – Albion to Riverdale Park Station
        </p>
        <p className="descrip">
          The cities of College Park and Riverdale Park unveiled a new sidewalk
          in April connecting the two communities.
          <br /> <br />
          The project required cooperation from both cities, as well as the
          Washington Metropolitan Area Transit Authority, which owned the land
          the sidewalk was built on.
        </p>

        <p className="p-heading">
          Expanded and improved bus service serving the city and Route 1
        </p>
        <p className="descrip">
          Maryland National Capital Park and Planning conducted a study earlier
          this year to determine how the bus service in the area could be
          improved, Olson wrote in an email. When the results of the study are
          released, the city plans to use them to improve the transportation
          system as a whole.
          <br />
          <br />
          Meanwhile, as reported by The Diamondback earlier this month, shuttle
          bus fees have increased by $6 per undergraduate student and $3 per
          graduate student since 2015, according to the Bursar Office’s website.
          Currently, full-time graduates and undergraduates each pay $100.50 per
          semester for the services.
          <br />
          <br />
          DOTS Executive Director said an about $700,000 deficit would force the
          department to adjust several bus routes, including eliminating the
          weekend bus to the College Park Metro station and decreasing bus
          circulation to and from Courtyards.
          <br />
          <br />
          “There’s no situation where someone would want to cut bus routes. But
          when faced with this situation, you have to make the best decision you
          can make,” Allen said.
        </p>

        <p className="p-heading">Expanded MARC Service on the Camden Line</p>
        <p className="descrip">
          In 2015, three trains were added to the Camden Line, which connects
          D.C. to Baltimore and stops in College Park.
          <br /> <br />
          The partnership “helped orchestrate media events” promoting the
          expansion, according to its website.
        </p>

        <p className="p-heading">mBike bike-share program launched</p>
        <p className="descrip">
          As city and university officials seek to make the region more
          hospitable for pedestrians and bikes alike, students and city
          residents are able to use bike-share options in lieu of cars or public
          transportation.
          <br /> <br />
          The mBike program, a three-year pilot program started in May 2016, is
          a partnership between this university, the city of College Park and
          bike-share company Zagster. It provides bikes at 23 stations in the
          College Park area and on the campus. More than 3,700 riders have taken
          more than 62,000 trips in the two years since the program launched,
          according to mBike data.
          <br />
          <br />
          With a year left, university and city officials will begin negotiating
          to either extend the contract with Zagster or go in another direction.
          <br />
          <br />
          DOTS spokesperson Anna McLaughlin said the department was “very happy
          with mBike” and would like to extend the contract if possible.
          <br />
          <br />
          “We have no reason not to, unless [Zagster] can’t provide something we
          would find critical,” she said.
        </p>

        <h3 className="list-heading">
          Highlights of the Transportation 2018 Work Plan
        </h3>

        <p className="p-heading">Route 1 pedestrian safety improvements</p>
        <p className="descrip">
          According to city officials, construction on the first phase of the
          state-funded Route 1 redevelopment will begin this year. Improvements
          will include bike lanes, wider sidewalks, medians and designated turn
          lanes between College Avenue and Route 193.
          <br /> <br />
          “It should be a safer place for cyclists, bicyclists and motorists,”
          Olson said, “and also help the traffic move through more
          consistently.”
          <br />
          <br />
          He said Route 1 will eventually be upgraded up to the Beltway, but
          those plans are still in the preliminary stages.
          <br />
          <br />
          “I think personally they could make Route 1 less [like a] highway and
          fast and make it more like a town and slower,” College Park resident
          Laura McGrath Hood said. “It would also make our students a little
          safer.”
        </p>

        <p className="p-heading">Bus Transit</p>
        <p className="descrip">
          This university’s Department of Transportation Services recently
          announced the elimination or reduction of service on several shuttle
          bus routes, which will go into effect July 1.
          <br /> <br />
          According to Allen, the cuts were intended to address a budget deficit
          of at least $700,000.
          <br />
          <br />
          But as per its website, the partnership will “work to increase the
          availability, frequency and efficiency of bus transit in the city.”
        </p>

        <p className="p-heading">Parking Study</p>
        <p className="descrip">
          In March, this university’s Department of Transportation Services
          announced Lot 1 would lose more than 250 parking spaces in the fall
          2018 semester due to Purple Line construction.
          <br />
          <br />
          The campus has seen scores of parking spaces disappear over the past
          several years due to other construction projects. About 200 spots near
          the Jeong H. Kim Engineering building were removed in 2015, and
          another 400 went away due to construction of the Brendan Iribe Center
          for Computer Science and Innovation.
        </p>

        <p className="p-heading">Beltway Widening Proposal</p>
        <p className="descrip">
          In September, Maryland Gov. Larry Hogan announced a $9 billion
          proposal to widen three major highways in the region, including
          Interstate 270, the Baltimore-Washington Parkway and the Beltway.
          <br />
          <br />
          A private company would complete the project, managing multiple toll
          lanes added to each highway.
        </p>
      </div>
    </section>
  );
};

export default Transportation;



// WEBPACK FOOTER //
// ./src/views/Transportation.jsx